import styled from 'styled-components';

export const Container = styled.div({
  width: '20rem',
  height: '100%',
  alignSelf: 'center',
  marginRight: '20rem',
  marginTop: '15rem',
});

export const CardSaleImg = styled.img({
  // Requires !important to override AntD styles
  height: '32rem !important',
  width: '32rem !important',
});
